import { AxiosResponse } from 'axios';
import client from 'api/client';

export function get(): Promise<AxiosResponse> {
    return client.get('/expertise_list');
}
